import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
  return `/video-contents`
};


function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },
    
    getItem: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.get(url);
    },
    
    create: (data: RequestData) => {
      return HttpRequest.post(getUrl(), data.payload, {});
    },
    
    addCategories: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/categories`;
      return HttpRequest.post(url, data.payload, {});
    },
    
    deleteCategories: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/categories`;
      return HttpRequest.delete(url, {
        data: data.payload
      });
    },
    
    addTags: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/tags`;
      return HttpRequest.post(url, data.payload, {});
    },
    
    deleteTags: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/tags`;
      return HttpRequest.delete(url, {
        data: data.payload
      });
    },
    
    addPersonRoles: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/personRoles`;
      return HttpRequest.post(url, data.payload, {});
    },
    
    deletePersonRoles: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/personRoles`;
      return HttpRequest.delete(url, {
        data: data.payload
      });
    },
    
    updateContentListStrategy: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/contentListStrategy`;
      return HttpRequest.put(url, {
        ...data.payload
      });
    },
    
    addContentListItems: (data: RequestData) => { 
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/contentListItems`;
      return HttpRequest.post(url, data.payload, {});
    },
    
    deleteContentListItems: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/contentListItems`;
      return HttpRequest.delete(url, {
        data: data.payload
      });
    },
    
    update: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.put(url, data.payload, {});
    },
    
    delete: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.delete(url, {});
    },
   
    getGalleryList: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/galleries?count=40`;
      return HttpRequest.get(url, data.payload, {});
    },
    
    createGallery: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/galleries`;
      return HttpRequest.post(url, data.payload, {});
    },
    
    updateGallery: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/galleries`;
      return HttpRequest.put(url, {
        ...data.payload
      });
    },
    
    deleteGallery: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/galleries`;
      return HttpRequest.delete(url, {data: data.payload});
    },
  
    getFilesList: (data: RequestData) => {
      const url = `video-contents/${getPropByString(data, "params.id")}/videoFiles`;
      return HttpRequest.get(url, data.payload, {});
    },
  
    addFiles: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/videoFiles`;
      return HttpRequest.post(url, data.payload, {});
    },
  
    updateVideoFiles: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/videoFiles`;
      return HttpRequest.put(url, {
        ...data.payload
      });
    },
  
    deleteFiles: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/videoFiles`;
      return HttpRequest.delete(url, {data: data.payload});
    },
  
    updateFile: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/videoFiles/${getPropByString(data, "params.file_id")}`;
      return HttpRequest.put(url, data.payload, {});
    },
  
    getDashboardReport: ({ params }: RequestData) => {
      return HttpRequest.get(`${getUrl()}/most-viewed`, {
        params
      });
    },
  
    getItemViewReport: ({ params }: RequestData) => {
      return HttpRequest.get(`${getUrl()}/view/${params.id}`, {
        params
      });
    },
    
    getItemPurchaseReport: ({ params }: RequestData) => {
      return HttpRequest.get(`${getUrl()}/${params.id}/purchases`, {
        params
      });
    },
  };
}

export default api();
